import * as React from 'react'

const _ = require('lodash')
import { Card, Segment, Tab } from 'semantic-ui-react'
import { RollItemCard } from './RollItemCard'

type ItemDeckProps = {
  items: IGameItem[],
  onClickItem: ICallback2<IGameItem>,
  isCart?: boolean,
}

const renderRollItem = (item: IGameItem, onClickItem: ICallback2<IGameItem>): React.ReactNode => {
  return (
    <RollItemCard gameItem={item} onClickItem={() => onClickItem(item)}/>
  )
}

export const GameItemDeck: React.SFC<ItemDeckProps> = (props) => {
  const {items, onClickItem, isCart = false} = props
  const dotaItems: IGameItem[] = _.filter(items, {game: 'DOTA'})
  const csItems: IGameItem[] = _.filter(items, {game: 'CSGO'})

  if (isCart) {
    return (
      <Segment style={{overflow: 'auto', maxHeight: '500px', border: 'none'}}>
        <Card.Group>
          {items.map(gameItem => renderRollItem(gameItem, onClickItem))}
        </Card.Group>
      </Segment>
    )
  }

  return (
    <Tab
      panes={[
        {
          menuItem: 'DOTA',
          render: () => (
            <Segment style={{overflow: 'auto', maxHeight: '500px', border: 'none'}}>
              <Card.Group>
                {dotaItems.map(gameItem => renderRollItem(gameItem, onClickItem))}
              </Card.Group>
            </Segment>)
        },
        {
          menuItem: 'CS-GO',
          render: () => (
            <Segment style={{overflow: 'auto', maxHeight: '500px', border: 'none'}}>
              <Card.Group>
                {csItems.map(gameItem => renderRollItem(gameItem, onClickItem))}
              </Card.Group>
            </Segment>)
        },
      ]}
    />)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/components/GameItemDeck.tsx